import { render, staticRenderFns } from "./Rig.vue?vue&type=template&id=56031917&"
import script from "./Rig.vue?vue&type=script&lang=js&"
export * from "./Rig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56031917')) {
      api.createRecord('56031917', component.options)
    } else {
      api.reload('56031917', component.options)
    }
    module.hot.accept("./Rig.vue?vue&type=template&id=56031917&", function () {
      api.rerender('56031917', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/Rig.vue"
export default component.exports